import React from "react";
/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import io from "socket.io-client";
import { BASEURL } from "../../../../utilites";
import allActions from "../../../../Store/action";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserTopBar from "../../../../components/Messaging/UserTopBar";
import SubmitArea from "../../../../components/Messaging/SubmitArea";
// import MessageCard from "../../../../components/Messaging/MessageCard";
import { useIsTyping } from "../../../../components/Custom/UserisTyping.js";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { FIREBASE_ACTION_TYPE } from "../../../../Store/firebase/Type";
import { Scrollbar } from "react-scrollbars-custom";
import { useLocation } from "react-router-dom";
import { CALL_ACTION_TYPE } from "../../../../Store/call/Type";
import { db } from "../../../../config/firebase.js";
import axios from "axios";
import { updateDoc, doc, deleteDoc } from "firebase/firestore";
import { AiOutlineSearch } from "react-icons/ai";
import UsersList from "../../../../components/Messaging/UsersList";
import Loader from "../../../../components/Loader.js";
import { callAiModal } from '../../../../utilites/aiModal.js';
import { formatMessagesForAI } from '../../../../utilites/functions.js';
import ChatWindow from "./ChatWindow.js";
import { RiMessage2Line } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import { parsePhoneNumberFromString } from "libphonenumber-js";


const CustomerMessageBoardModal = ({
  uuid = false,
  group,
  editable = true,
  isDesktop,
  isTab,
  setShowCustomerMessageBoard,
  showCustomerMessageBoard,
  showMessageBoardButton
}) => {
  const [search, setSearch] = useState("");

  const count = 10;
  const scrollContainerRef = useRef();
  const scrollContainerRef1 = useRef();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [load, setLoad] = useState(false);
  const domainsNotAllowed = ["calendly.com"];
  const [initialLoad, setInitialLoad] = useState(count);
  const [showUserList, setShowUserList] = useState(false);
  // const count = 10;
  const dispatch = useDispatch();
  const messagesEndRef = useRef(null);
  const params = useLocation();
  // const scrollContainerRef = useRef();
  // const scrollContainerRef1 = useRef();

  const { user, dashboard } = useSelector((state) => state);
  const { LoginData, loginStatus } = useSelector((state) => state.user);
  let {
      saveDocId,
      adminRole,
      storageLinks,
      readPersonalChats,
      writeStorageStatus,
      writePersonalStatus,
      personalConnections,
      writePersonalMessage,
      readPersonalChatsStatus,
      writePersonalReplyStatus,
      readPersonalChatsMessage,
      writePersonalReplyMessage,
      personalGroupConnections,
      chatStatus,
  } = useSelector((state) => state.firebase);
  personalConnections = group ? personalGroupConnections : personalConnections;
  const [isAiBotMode, setIsAiBotMode] = useState({enable:false,previousData:{}});
  const [isTyping, setIsTyping] = useIsTyping();
  const [isAITyping, setIsAITyping] = useState();
  const [chatUsers, setChatUsers] = useState([]);
  const [openChat, setOpenChat] = useState(false);
  const [imageLinks, setimageLinks] = useState([]);
  const [imagesArray, setImagesArray] = useState([]);
  const [manageLocal, setmanageLocal] = useState(false);
  const [messageContent, setMessageContent] = useState();
  const [, setMessage] = useState({ show: false });
  const [selectDefault, setSelectDefault] = useState(false);
  const [selectedReceiver, setselectedReceiver] = useState();
  const [seenCheckerEvent, setSeenCheckerEvent] = useState(0);
  // const [initialLoad, setInitialLoad] = useState(count);
  const [editId, setEditId] = useState(null);
  const [editText, setEditText] = useState("");
	const scrollRef = useRef(null);

  // const [load, setLoad] = useState(false);
  let myIds = [
    group && !group?.includes(undefined)
      ? group.find((data) => data !== uuid)
      : LoginData?.uuid,
    selectedReceiver?.uuid,
  ];
  const chatDisable =
    LoginData?.isTaxPro &&
    Number(
      dashboard?.leads?.data?.find(
        (data) => data?.user?.id === selectedReceiver?.id
      )?.status
    ) === 3;


  const notifyAdminsForChatWarnings = async (message) => {
    try {
      await axios.post(`${BASEURL}/api/mail/chat-warning-notification`, {
        data: {
          username: LoginData?.firstname + " " + LoginData?.lastname,
          userEmail: LoginData?.email,
          message: message,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
   const createViolationRecord = async (type,message,id) => {
    try {
           await axios.post(`${BASEURL}/api/violations`, {
        user_id: LoginData?.id,
        type_id: type,
        content: message,
        other_user_id: id,
      });
    } catch (error) {
      console.log('Failed to create violation:', error.response?.data || error.message);
    }
   };
   
   
  const handleScroll = () => {
    const scrollContainer = scrollContainerRef.current;
    const scrollContainer1 = scrollContainerRef1.current;
    // Check if the user has reached the bottom of the scroll container
    if (
      scrollContainer?.scrollTop + scrollContainer?.clientHeight >=
      scrollContainer?.scrollHeight - 1
    ) {
      handleMore();
      console.log("Reached the end of the scroll");
      // Perform any action you want when the scroll reaches the end
    }
    // Check if the user has reached the bottom of the scroll container
    if (
      scrollContainer1?.scrollTop + scrollContainer1?.clientHeight >=
      scrollContainer1?.scrollHeight - 1
    ) {
      handleMore();
      console.log("Reached the end of the scroll");
      // Perform any action you want when the scroll reaches the end
    }
  };

  const handleMore = () => {
    if (initialLoad < chatUsers?.length) {
      setLoad(true);
      setTimeout(() => {
        setInitialLoad(initialLoad + count);
        setLoad(false);
      }, 2000);
    } else {
      setInitialLoad(chatUsers?.length);
    }
  };

// AI integration 
const getAIResponse = async ({message=null}) => {
	if(getEditorText(editorState)==='' && !message)return;
  setTimeout(() => {setIsAITyping(true)}, 500);
  const messages = formatMessagesForAI(readPersonalChats);
  messages.push({ role: 'user', content:message || getEditorText(editorState) });
  const aiReply = await callAiModal(messages , LoginData?.isCustomer ? "customer" : "others");
  // Push AI reply back to chatHistory for next request
  handleSubmit({ type: 'ai/Response', encodedString:aiReply });
  setTimeout(() => {setIsAITyping(false)}, 500);
};

  // --------------------------------------------
  // HOOKS (UseEffect used For Different Purposes)
  // --------------------------------------------

  // *****--Hooks To Handle Paste Image--****
  useEffect(() => {
    if (chatDisable) return;
    const handlePaste = (event) => {
      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;
      const newImages = [];

      for (const item of items) {
        if (item.kind === "file" && item.type.startsWith("image/")) {
          const file = item.getAsFile();
          newImages.push(file);
        }
      }
      if (newImages.length > 0) {
        fileUpload(newImages[0], "add");
      }
    };

    document.addEventListener("paste", handlePaste);

    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, [imagesArray]);


  // *****--Hooks To check image Upload--****
  useEffect(() => {
    if (writeStorageStatus === true) {
      setimageLinks(storageLinks);
    }
    if (!writeStorageStatus) {
      setMessage({
        show: true,
        type: "Error",
        text: "Something Went Wrong While Uploading media",
      });
    }
  }, [storageLinks, writeStorageStatus]);

  // *****--Hooks To check that user is Typing or not--****
  useEffect(() => {
    handleIsTyping(isTyping);
  }, [isTyping]);

  //  *****--HOOKS Which work on Enter key press trigger event--****
  useEffect(() => {
    setOpenChat(false);
    window.addEventListener("keypress", (e) => {
      if (e.key === "Enter" && document.getElementById("sendMessage")) {
        document.getElementById("sendMessage").submit();
      }
    });
    // Use Interval to get latest Status of Last Seen
    setInterval(() => {
      setSeenCheckerEvent(seenCheckerEvent + Math.random() * 10000);
    }, 60000);
  }, []);

  //  *****--HOOKS To Retrive Chat Users(last seen , Online /offline)--****
  useEffect(() => {
    if (chatUsers?.length > 0) {
      dispatch(allActions.firebase.getFirebaseUsers(chatUsers));
    }
  }, [chatUsers]);

  //  *****--HOOKS To Apply Filter on Chats according to Last Chat--****
  useEffect(() => {
    manageFilter(loginStatus, adminRole.loaded, personalConnections);
  }, [
    loginStatus,
    adminRole.loaded,
    personalConnections,
    openChat,
    user,
    chatUsers.length,
  ]);

  // *****--Handle Store Response Of Create Topic--*****
  useEffect(() => {
    dispatch(allActions.firebase.resetWritePersonalMessage());

    if (!writePersonalStatus) {
      setmanageLocal(false);
      setMessage({
        show: true,
        type: "Error",
        text: writePersonalMessage,
      });
    }
    if (writePersonalStatus === true) {
      loadChats(selectedReceiver, false, true);
      // reset Meeting Link
      dispatch(
        allActions.call.dispatchToStore({
          type: CALL_ACTION_TYPE.videoCallRoomIdle,
        })
      );
    }
  }, [writePersonalStatus, writePersonalMessage]);

  // *****--Handle Store Response Of Reply Chat--*****
  useEffect(() => {
    if (!writePersonalReplyStatus) {
      setmanageLocal(false);
      setMessage({
        show: true,
        type: "Error",
        text: writePersonalReplyMessage,
      });
    }
    if (writePersonalReplyStatus === true) {
      setmanageLocal(false);
      // reset Meeting Link
      dispatch(
        allActions.call.dispatchToStore({
          type: CALL_ACTION_TYPE.videoCallRoomIdle,
        })
      );
    }
  }, [writePersonalReplyStatus, writePersonalReplyMessage]);

  // *****--Handle Store Response Of Read Chats--*****
  useEffect(() => {
    if (readPersonalChatsStatus === false) {
      setmanageLocal(false);
      setMessage({
        show: true,
        type: "Error",
        text: readPersonalChatsMessage,
      });
      setOpenChat(true);
    }
    if (readPersonalChatsStatus === true) {
      setmanageLocal(false);
      setSelectDefault(undefined);
      setOpenChat(true);
      if (saveDocId === selectedReceiver?.docId && !group) {
        dispatch(
          allActions.firebase.updateNotification({
            docId: saveDocId,
            notificationObj: { [LoginData?.uuid]: 0 },
          })
        );
      }
      setTimeout(() => {
        messagesEndRef.current?.scrollToBottom();
      }, 10);
    }
  }, [readPersonalChatsStatus, readPersonalChatsMessage, readPersonalChats]);

  // GET DATA
  useEffect(() => {
    // FOR TAX PRO
    if (
      loginStatus &&
      !user?.isRegular &&
      !user?.isAdmin &&
      !user?.isAccountManager
    ) {
      dispatch(allActions.dashboard?.getAllLeads("", ""));
    }

    // FOR ADMIN
    if (loginStatus && !user?.isRegular && !user?.isTaxPro && dashboard?.users?.data?.length < 1) {
      dispatch(allActions.dashboard?.getAllUsers("", ""));
    }

    // FOR ACCOUNT MANAGER
    if (loginStatus && user?.isAccountManager ) {
      dispatch(allActions.dashboard?.getAllLeads("", ""));
    }
    if (loginStatus && user?.isAccountManager && dashboard?.users?.data?.length < 1) {
      dispatch(allActions.dashboard?.getAllUsers("", ""));
    }
  }, [window.location.href]);

  // *****--Load Customer & Account manager If User is Tax Pro--*****
  useEffect(() => {
    if (
      loginStatus &&
      !user?.isRegular &&
      !user?.isAdmin &&
      !user?.isAccountManager &&
      dashboard?.leads.loaded &&
      adminRole.loaded === true
    ) {
      let options = [];
      let filteredData = dashboard?.leads?.data?.map((data) => {
        return {
          role: "Customer",
          id: data?.user?.id,
          uuid: data?.user?.uuid,
          lastname: data?.user?.lastname,
          firstname: data?.user?.firstname,
          email: data?.user?.email,
          phone: data?.phone,
          avatar: data?.user?.avatar,
          settings: data?.user?.settings,
        };
      });
      options = filteredData;
      // check account manager exist or not
      if (user?.LoginData?.userpro?.manager) {
        let manager = user?.LoginData?.userpro?.manager;
        manager.role = "Account Manager";
        options.push(manager);
      }

      let admin = adminRole?.data?.map((data) => {
        return {
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
          id: data?.roles[0].userrole?.user_id,
          uuid: data?.uuid,
          role: "Admin",
          avatar: data?.avatar,
        };
      });
      options=[...options , ...admin];
      setChatUsers(options);
      manageFilter(loginStatus, adminRole.loaded, personalConnections);
    }
  }, [
    loginStatus,
    dashboard?.leads.data,
    user?.isRegular,
    user?.isAdmin,
    user.isAccountManager,
    adminRole.loaded,
  ]);
  // *****--Load Customers & TaxPro If User is Admin--*****
  useEffect(() => {
    if (
      loginStatus &&
      !user?.isRegular &&
      !user?.isTaxPro &&
      dashboard?.allUsers.loaded &&
      !user?.isAccountManager
    ) {
      let filteredData = dashboard?.allUsers?.data
        .filter((data) => {
          if (!group) return data.roles[0].name !== "customer";
          else return data;
        })
        ?.map((data) => {
          if (data.roles[0].display_name !== "Admin") {
            return {
              firstname: data?.firstname,
              lastname: data?.lastname,
              email: data?.email,
              id: data?.id,
              uuid: data?.uuid,
              role: data?.roles[0]?.display_name,
              phone: data?.userpro?.phone,
              avatar: data?.avatar,
              settings: data?.settings,
            };
          } else return undefined;
        });
      let others = filteredData.filter((data) => data !== undefined);
      setChatUsers(others);
      manageFilter(loginStatus, adminRole.loaded, personalConnections);
    }
  }, [
    loginStatus,
    dashboard.allUsers.data,
    user?.isTaxPro,
    user?.isRegular,
    user?.isAccountManager,
  ]);

  // *****--Load TaxPro & Account manager If User is Customer--*****
  useEffect(() => {
    let options = [];
    if (
      loginStatus &&
      !user?.isTaxPro &&
      !user?.isAdmin &&
      !user?.isAccountManager
      // &&
      // adminRole.loaded === true
    ) {
      let taxpro = LoginData?.lead[0]?.userpro?.user;
      if (taxpro) {
        taxpro.role = "Tax Pro";
				taxpro.phone=LoginData?.lead[0]?.userpro?.phone;
        options.push(taxpro);
      }
      // check account manager exist or not
      if (LoginData?.lead[0]?.userpro?.manager) {
        let manager = LoginData?.lead[0]?.userpro?.manager;
        manager.role = "Account Manager";
        options.push(manager);
      }
      // handle admin role there
      // let admin = adminRole?.data?.map((data) => {
      // 	return {
      // 		firstname: data?.firstname,
      // 		lastname: data?.lastname,
      // 		id: data?.roles[0].userrole?.user_id,
      // 		uuid: data?.uuid,
      // 		role: "Admin",
      // 	};
      // });
      // options.push(admin[0]);
      setChatUsers(options);
      manageFilter(loginStatus, adminRole.loaded, personalConnections);
    }
  }, [
    loginStatus,
    user?.isTaxPro,
    user?.isAdmin,
    user?.isAccountManager,
    LoginData,
    // adminRole.loaded,
  ]);

  // *****--RESET STATE--*****
  useEffect(() => {
    setOpenChat(false);
  }, [window.location.href]);

  // *****--Check Leads Exist or not & Customers as well  if user is account manager--*****
  useEffect(() => {
    // check leads exist or not
    if (
      loginStatus &&
      !user?.isRegular &&
      !user?.isAdmin &&
      !user?.isTaxPro &&
      dashboard?.allUsers.loaded &&
      adminRole.loaded === true
    ) {
      let options = [];
      // check users exist or not
      let filteredUsersData = dashboard?.allUsers?.data?.map((data) => {
        return {
          id: data?.id,
          uuid: data?.uuid,
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
          role: data?.roles[0]?.display_name,
          phone: data?.userpro.phone,
          avatar: data?.avatar,
          settings: data?.settings,
        };
      });
      options = filteredUsersData;
      let admin = adminRole?.data?.map((data) => {
        return {
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
          id: data?.roles[0].userrole?.user_id,
          uuid: data?.uuid,
          role: "Admin",
          avatar: data?.avatar,
        };
      });
      options=[...options , ...admin];
      console.log("CHECKK>>>>>>>", options);
      setChatUsers(options);
      manageFilter(loginStatus, adminRole.loaded, personalConnections);
    }
  }, [
    loginStatus,
    dashboard?.allUsers.loaded,
    user?.isRegular,
    user?.isTaxPro,
    user?.isAdmin,
    adminRole.loaded,
  ]);

  // *****--Handle Store Response Of Loading Of Every HOOKS--*****
  useEffect(() => {
    // check user is login
    if (loginStatus) {
      if (
        manageLocal === true ||
        // For Leads Put Condition
        (!user?.isRegular && !user?.isAdmin && !dashboard?.leads.loaded) ||
        // For Customer Put Condition
        (!user?.isTaxPro &&
          !user?.isAdmin &&
          !LoginData?.lead[0]?.userpro?.user) ||
        // For Getting Admin user
        (!user?.isAdmin ? adminRole.loaded !== "idle" : false) ||
        // personal firebase connection details
        personalConnections?.loaded === "idle"
      ) {
        // dispatch(allActions.global.Loader(true));
        setLoad(true)
      }
      if (
        // For Leads Put Condition
        ((!user?.isRegular && !user?.isAdmin && dashboard?.leads.loaded) ||
          // For Customer Put Condition
          (!user?.isTaxPro &&
            !user?.isAdmin &&
            LoginData?.lead[0]?.userpro?.user) ||
          // For admin Put Condition
          (!user?.isTaxPro &&
            !user?.isTaxPro &&
            !user?.isAccountManager &&
            dashboard?.allUsers.loaded)) &&
        manageLocal === false &&
        // For Getting Admin user
        (!user?.isAdmin ? adminRole.loaded !== "idle" : true) &&
        // personal firebase connection details
        personalConnections?.loaded === true
      ) {
        // dispatch(allActions.global.Loader(false));
        setLoad(false)
      }
    }
  }, [
    dashboard?.allUsers.loaded,
    dashboard?.leads.loaded,
    user.isRegular,
    user.isAdmin,
    user.isTaxPro,
    user.isAccountManager,
    LoginData?.lead,
    manageLocal,
    loginStatus,
    adminRole?.loaded,
    personalConnections?.loaded,
  ]);
  // *****--Function to Manage Filter According to Last Chat--****
  const manageFilter = () => {
    if (adminRole.loaded === "idle" && loginStatus) {
      dispatch(allActions.firebase.getAdminUser());
    }
    // Read personalConnections if not loaded
    if (personalConnections?.loaded === "idle" && loginStatus) {
      dispatch(allActions.firebase.readPersonalConnections(LoginData?.uuid));

      if (
        group &&
        !group?.includes(undefined) &&
        group.find((data) => data !== uuid)
      ) {
        dispatch(
          allActions.firebase.readPersonalGroupConnections(
            group.find((data) => data !== uuid)
          )
        );
      }
      // Submit User Id
      dispatch({
        type: FIREBASE_ACTION_TYPE.myUuid,
        uuid:
          group && !group?.includes(undefined)
            ? group.find((data) => data !== uuid)
            : LoginData?.uuid,
      });
    }
    if (personalConnections?.loaded === true) {
      filteredChatUsers(personalConnections.data);
    }
  };
  const htmlToEditorState = (html) => {
    const blocksFromHTML = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    return EditorState.createWithContent(contentState);
  };
  useEffect(() => {
    if (editText && editId) {
      setEditorState(htmlToEditorState(editText));
    } else if (editText === "") {
      setEditorState(EditorState.createEmpty());
    }
  }, [editId]);

  //  *****--Function to Manage Handle Is Typing--****
  const handleIsTyping = (isTyping) => {
    let filteredConnection = personalConnections?.data?.filter(
      (data) => data?.ids?.includes(myIds[1]) && data?.ids?.includes(myIds[0])
    );

    // if user connection not exist
    if (filteredConnection.length === 0 && isTyping === true) {
      let topicObject = {
        title: "General Chat Room",
        senderId: LoginData?.uuid,
        receiverId: selectedReceiver?.uuid,
        createdAt: new Date(),
        draft: [],
        isTyping: [LoginData?.uuid],
      };
      dispatch(allActions.firebase.writeChatPersonalConnection(topicObject));
    }

    if (filteredConnection.length !== 0) {
      // if user connection exist
      if (!isTyping) {
        dispatch(
          allActions.firebase.updateConnection(
            filteredConnection?.[0]?.docId,
            LoginData?.uuid,
            "remove"
          )
        );
      } else {
        dispatch(
          allActions.firebase.updateConnection(
            filteredConnection?.[0]?.docId,
            LoginData?.uuid,
            "add"
          )
        );

        if (filteredConnection?.[0]?.docId && LoginData?.uuid) {
          const socket = io(BASEURL, { transports: ["websocket"] });
          socket.emit("IsTyping", {
            uuid: LoginData?.uuid,
            docId: filteredConnection?.[0]?.docId,
          });
        }
      }
    }
  };

  //  *****--Function to Retrive User Chats--****
  const loadChats = (data, openChat, loading) => {
    if (
      LoginData?.uuid === undefined ||
      data?.uuid === undefined ||
      openChat === true
    ) {
      return;
    }
    if (!loading) {
      setmanageLocal(true);
    }
    setselectedReceiver(data);
    setMessage({ show: false });
    let myIds = [
      group && !group?.includes(undefined)
        ? group.find((data) => data !== uuid)
        : LoginData?.uuid,
      data?.uuid,
    ];
    let filteredConnection = personalConnections?.data?.find(
      (data) => data?.ids?.includes(myIds[1]) && data?.ids?.includes(myIds[0])
    );
    setSelectDefault(true);
    if (filteredConnection === undefined) {
      // if a connection not exist create a new connection for that
      dispatch(allActions.firebase.resetReadPersonalChatsArray());
      dispatch(allActions.firebase.saveDocID("idle"));
      setmanageLocal(false);
      setOpenChat(false);
    } else {
      let notificationObj = {
        docId: filteredConnection?.docId,
        notificationObj: { [LoginData?.uuid]: 0 },
      };
      if (parseInt(filteredConnection[LoginData?.uuid]) !== 0 && !group) {
        // Update Notificaiton Here
        dispatch(allActions.firebase.updateNotification(notificationObj));
      }
      dispatch(allActions.firebase.saveDocID(filteredConnection?.docId));
      dispatch(
        allActions.firebase.readPersonalChats(
          filteredConnection?.docId,
          LoginData?.uuid
        )
      );
    }
    // Reset Values and Storage Media
    resetValues();
  };
  //  *****--Function to Filter Chat Users--****
  const filteredChatUsers = (connection) => {
    chatUsers?.map((data) => {
      let filtered = connection.find((v) => v?.ids?.includes(data?.uuid || ""));
      if (filtered) {
        data["updatedAt"] = filtered["updatedAt"];
        data[LoginData?.uuid] = filtered[LoginData?.uuid];
        data["docId"] = filtered["docId"];
      }
      return 0;
    });
    const sortedArray = chatUsers
      .slice()
      .sort((a, b) => (a.updatedAt ? b.updatedAt - a.updatedAt : 1) || -1);

    // Check if Array Contain Element then Save
    if (sortedArray.length > 0) {
      setChatUsers(group ? chatUsers.slice() : sortedArray);
    }
    // if from params any data came open that data chat
    if (params?.state?.uuid && !selectDefault && !openChat) {
      dispatch(allActions.firebase.resetReadPersonalChatsArray());
      loadChats(
        sortedArray.find((data) => data?.uuid === params?.state?.uuid),
        openChat
      );
      return;
    }
    if (uuid && sortedArray.find((data) => data?.uuid === uuid) && !openChat) {
      dispatch(allActions.firebase.resetReadPersonalChatsArray());
      loadChats(
        sortedArray.find((data) => data?.uuid === uuid),
        openChat
      );
      return;
    }
    // else open first chat
    if (!selectDefault && !openChat) {
      dispatch(allActions.firebase.resetReadPersonalChatsArray());
      loadChats(sortedArray[0], openChat);
    }
  };
  //  *****--Function to Reset New Connection Write--****
  const resetWriteConnection = () => {
    // reset Socket backup images
    const socket = io(BASEURL, { transports: ["websocket"] });
    socket.emit("removeImageUpload", storageLinks);

    // Reset Local States
    setImagesArray([]);
    setimageLinks([]);
    dispatch({ type: FIREBASE_ACTION_TYPE.storageLinks, payload: [] });
    setMessage({ show: false });
    dispatch(allActions.firebase.resetReplyPersonalMessage());
  };

  // Extract plain text
  const getEditorText = (editorState) => {
    return convertToRaw(editorState.getCurrentContent())
      .blocks.map((block) => block.text)
      .join("\n");
  };

  //  *****--Function to Submit Chat || Connection --****
const handleSubmit = ({
  type,
  encodedString,
  rawMessage,
  aiMode = false,
  overrideReceiver = null, 
}) => {
  const message = rawMessage;

     // Function to check if an email address is present
    const containsEmailAddress = (text) => {
      const emailRegex =
        /\b[A-Z0-9._%+-]+\s?@\s?[A-Z0-9.-]+\s?\.\s?[A-Z]{2,}\b/gi;
      return emailRegex.test(text);
    };

    // Function to check if an email domain is present
    const containsRestrictedEmailDomain = (text) => {
      const domainRegex =
        /@gmail\.com|@yahoo\.com|@outlook\.com|@hotmail\.com|@\w+\.\w+/gi;
      return domainRegex.test(text);
    };
  
 const containsPhoneNumber = (text, region = "US") => {
  if (!text || !text.trim()) return false;

  const candidates = text.match(/[\d\s().+-]{7,}/g) || [];
  for (const c of candidates) {
    const phone = parsePhoneNumberFromString(c, region);
    if (phone && phone.isValid()) return true;
  }
  return false;
};


  const containsRestrictedDomain = (text, restrictedDomains) => {
    const domainPattern = restrictedDomains.join("|").replace(/\./g, "\\.");

    const linkRegex = new RegExp(
      `<a[^>]*href=["'](https?:\\/\\/(www\\.)?(${domainPattern})[^"']*)["'][^>]*>.*?<\\/a>`,
      "gi"
    );
    const rawDomainRegex = new RegExp(
      `(?:https?:\\/\\/)?(?:www\\.)?(${domainPattern})\\b`,
      "gi"
    );

    return linkRegex.test(text) || rawDomainRegex.test(text);
  };

function containsWebsite(message) {
  const text = typeof message === "string" ? message : message?.text || "";

  const urlRegex = /\b((https?:\/\/)|(www\.))[\w-]+(\.[\w-]+)+([\/?#]\S*)?\b/gi;

  return urlRegex.test(text);
}
  const aiEnabled = aiMode ? false : Boolean(isAiBotMode?.enable);

  const receiver = overrideReceiver || selectedReceiver;
  if (!receiver) return;

  if (!LoginData?.isAdmin) {
    if (containsEmailAddress(message)) {
      notifyAdminsForChatWarnings(message);
      createViolationRecord(0, message, receiver?.id); 
    } else if (containsRestrictedEmailDomain(message)) {
      notifyAdminsForChatWarnings(message);
      createViolationRecord(0, message, receiver?.id);
    } else if (containsPhoneNumber(message)) {
      notifyAdminsForChatWarnings(message);
      createViolationRecord(1, message, receiver?.id);
    } else if (containsWebsite(message)) {
      notifyAdminsForChatWarnings(message);
      createViolationRecord(2, message, receiver?.id);
    } else if (containsRestrictedDomain(message, domainsNotAllowed)) {
      notifyAdminsForChatWarnings(message);
      createViolationRecord(2, message, receiver?.id);
    }
  }

  if (receiver === undefined || chatDisable) return;
  if (
    (messageContent === "<p></p>\n" || messageContent === undefined) &&
    imageLinks.length === 0 &&
    encodedString === undefined
  ) {
    return;
  }

  const ids = [
    group && !group?.includes(undefined) ? group.find((d) => d !== uuid) : LoginData?.uuid,
    receiver?.uuid,
  ];

  let filteredConnection = personalConnections?.data?.filter(
    (d) => d?.ids?.includes(ids[1]) && d?.ids?.includes(ids[0])
  );

  resetWriteConnection();

  const profileObj = {
    settings: {
      ...LoginData?.settings,
      firstMessageSent: true,
    },
  };

  if (filteredConnection.length === 0) {
    // new thread
    const topicObject = {
      title: "General Chat Room",
      body: encodedString
        ? encodedString
        : messageContent === "<p></p>\n"
        ? ""
        : messageContent,
      senderId: LoginData?.uuid,
      receiverId: receiver?.uuid,    
      createdAt: new Date(),
      draft: [],
      updatedAt: new Date(),
      isTyping: [LoginData?.uuid],
      messageType: type,
    };
    const addMessage = true;

    dispatch(allActions.firebase.writeChatPersonalConnection(topicObject, addMessage));
  } else {
    // existing thread
    const chatObject = {
      body: encodedString
        ? encodedString
        : messageContent === "<p></p>\n"
        ? ""
        : messageContent,
      senderId: LoginData?.uuid,
      receiverId: receiver?.uuid,    
      createdAt: new Date(),
      messageType: type,
    };

    const updateChatConn = {
      [receiver?.uuid]: filteredConnection?.[0]?.[receiver?.uuid] + 1, 
      updatedAt: new Date(),
    };

    if (imageLinks.length > 0) {
      chatObject.images = imageLinks;
    }

    dispatch(
      allActions.firebase.writeChatPersonalReply(
        chatObject,
        filteredConnection?.[0].docId,
        updateChatConn
      )
    );

    if (!LoginData?.settings?.firstMessageSent) {
      dispatch(
        allActions.dashboard.updateProfile({
          uuid: LoginData?.uuid,
          profileObj,
        })
      );
    }
  }

  const status = allActions.firebase.getMyStatus(
    chatStatus?.data,
    receiver?.uuid, 
    "status"
  );

  if (status !== "online" && !aiEnabled) {
    dispatch(
      allActions.sgMail.sendMailReminder({
        customerEmail: receiver.email,                
        operatorFirstname: user?.LoginData?.firstname,
        operatorAvatar: user?.LoginData?.avatar[0]?.path,
        shortenedMessage: encodedString
          ? encodedString.slice(0, 144) + "..."
          : messageContent === "<p></p>\n"
          ? ""
          : messageContent?.slice(0, 144) + "...",
        accountId: receiver?.uuid,                    
        phone: receiver?.phone,                      
      })
    );
  }

  // cleanup
  resetValues();
  // prevIsAiBotModeRef.current = null;
};
const handleEdit = async (docId, newBody) => {
  const filteredConnection = personalConnections?.data?.filter(
    (data) => data?.ids?.includes(myIds[1]) && data?.ids?.includes(myIds[0])
  );

  const docRef = doc(db, "messages", filteredConnection[0]?.docId, "chats", docId);

  const topicObject = {
    body: typeof newBody === "string" ? newBody : editText, // fallback
    updatedAt: new Date(),
  };

  try {
    await updateDoc(docRef, topicObject);
    setEditId(null);
    setEditText("");
  } catch (error) {
    console.error("Error in message update:", error);
  }
};

    const handleDeleteMessage = async (docId) => {
    let filteredConnection = personalConnections?.data?.filter(
        (data) => data?.ids?.includes(myIds[1]) && data?.ids?.includes(myIds[0])
      );
      const docRef = doc(db, 'messages', filteredConnection[0]?.docId, 'chats', docId );
      let topicObject = {
        body: 'This message has been deleted',
        updatedAt: new Date()
      }
      try {
        await deleteDoc(docRef, topicObject );
      } catch (error) {
        console.error('Error in message update:', error);
      }
  }
  const handleKeyPress = (event) => {
    // Shift+Enter: let browser insert newline naturally (textarea handles it)
    // Enter without Shift: handled by ExpandableInput's onKeyDown
  };
  const fileUpload = (file, option) => {
    if (!file) return;

    let path = `user/${LoginData?.uuid}/${Date.now()}`;
    let emitPath = {
      uuid: LoginData?.uuid,
      path,
    };
    setMessage({ show: false });
    dispatch(allActions.firebase.writeStorageIdle());
    dispatch(allActions.firebase.writeStorge(path, file, emitPath));

    if (option === "add") {
      file.path = path;
      let images = [...imagesArray, file];
      setImagesArray(images);
    }
  };
  const handleRemoveImage = (imageObject) => {
    if (imageObject?.path) {
      // local Array image
      const newArray = imagesArray.filter((e) => {
        return e.path !== imageObject.path;
      });
      setImagesArray(newArray);

      // local Already Uploded Link
      let linksArray = imageLinks.filter((e) => {
        return e.path !== imageObject.path;
      });
      setimageLinks(linksArray);
      // local Already Uploded Link
      let storageLinkArray = storageLinks.filter((e) => {
        return e.path !== imageObject.path;
      });
      dispatch({
        type: FIREBASE_ACTION_TYPE.storageLinks,
        payload: storageLinkArray,
      });

      // // Remove Emit Socket
      const socket = io(BASEURL, { transports: ["websocket"] });
      socket.emit("removeImageUploadPerm", imageObject?.path);
    }
  };
  const resetValues = () => {
    // Reset Messages
    setMessageContent(undefined);
    setEditorState(EditorState.createEmpty());
    setImagesArray([]);
    setimageLinks([]);
    dispatch({ type: FIREBASE_ACTION_TYPE.storageLinks, payload: [] });
  };
  // const handleScroll = () => {
  // 	const scrollContainer = scrollContainerRef.current;
  // 	const scrollContainer1 = scrollContainerRef1.current;
  // 	// Check if the user has reached the bottom of the scroll container
  // 	if (
  // 		scrollContainer.scrollTop + scrollContainer.clientHeight >=
  // 		scrollContainer.scrollHeight - 1
  // 	) {
  // 		handleMore();
  // 		console.log('Reached the end of the scroll');
  // 		// Perform any action you want when the scroll reaches the end
  // 	}
  // 	// Check if the user has reached the bottom of the scroll container

  // };

  // const handleMore = () => {
  // 	if (initialLoad < chatUsers?.length) {
  // 		setLoad(true);
  // 		setTimeout(() => {
  // 			setInitialLoad(initialLoad + count);
  // 			setLoad(false);
  // 		}, 2000);
  // 	} else {
  // 		setInitialLoad(chatUsers?.length);
  // 	}
  // };



    const toggleAiBotMode = (isEnabled, share) => {
      if (isEnabled) {
        const aiBotUser = {
          firstname: "AI",
          lastname: "Bot",
          uuid: `${LoginData?.uuid}AIBOT`,
          email: "aiBot@uncklekam.com",
          role: "AI Bot",
          [LoginData.uuid]: 0,
          docId: `${LoginData?.uuid}AIBOT`,
        };
    
        if (loadChats && !LoginData?.isCustomer) {
          setOpenChat(false);
          dispatch(allActions.firebase.resetReadPersonalChatsArray());
          loadChats(aiBotUser, false);
        }
    
        setIsAiBotMode({ enable: true, previousData: selectedReceiver });
      } else {
        const prevReceiver = isAiBotMode.previousData || selectedReceiver;
        const processed = processPlainTextMessage(share?.data?.body || '');
    
        if (share?.autoSubmit  && prevReceiver) {
          handleSubmit({
            type: "simple",
            encodedString: `<p>${processed}</p>`,
            rawMessage: processed,
            aiMode: true,                
            overrideReceiver: prevReceiver, 
          });
        }
    
        setIsAiBotMode({ enable: false, previousData: {} });
    
        if (!LoginData?.isCustomer && prevReceiver) {
          setOpenChat(false);
          dispatch(allActions.firebase.resetReadPersonalChatsArray());
          loadChats(prevReceiver, false);
        }
      }
    };
    
    
	let isAiTalkBefore = readPersonalChats?.find(e => e.messageType === 'ai/Response')
	let aiFirstQuestion = [{
		"messageType": "simple",
		"receiverId": "5ddc1we5b-8a7b-408f-a4bf-1f217fba48a4AIBOT",
		"createdAt": "2025-05-06T13:28:12.162Z",
		"body": "Hi! I am Uncle Kam’s AI Assistant 🤖<br />How may I help you today?",
		"senderId": "5ddc1e5wb-8a7b-408f-a4bf-1f217fba48a4",
		"docId": "yMtzwRnrYRm6xRdwIEsbb"
	}]

	const chatAreas = () => {
		return <ChatWindow
			readPersonalChats={JSON.parse(JSON.stringify(readPersonalChats.sort((a, b) => a?.createdAt - b?.createdAt)))}
			group={group}
			chatUsers={chatUsers}
			editId={editId}
			setEditId={setEditId}
			setEditText={setEditText}
			scrollRef={scrollRef}
      isInModal= {true}
      handleDeleteMessage ={handleDeleteMessage}
     	getAIResponse={getAIResponse} 
			isAITyping={isAITyping}
			handleSubmit={handleSubmit}
			toggleAiBotMode={toggleAiBotMode}
			isAiBotMode={isAiBotMode}
			LoginData={LoginData}
		/>
	}

  const processPlainTextMessage = (text) => {
  const html = `<p>${text.replace(/\n/g, '<br />')}</p>`; // convert line breaks to <br>

  const convertLinksToAnchorTags = (html) => {
    const regex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    const containsAnchorTag = /<a\s+href=["'].*?["'].*?>.*?<\/a>/i.test(html);
    return containsAnchorTag ? html : html.replace(regex, '<a href="$1" target="_blank">$1</a>');
  };

  const blurEmailAddresses = (html) => {
    const emailRegex = /\b[A-Z0-9._%+-]+\s?@\s?[A-Z0-9.-]+\s?\.\s?[A-Z]{2,}\b/gi;
    return html.replace(emailRegex, '<span class="blurred">fakeemail@gmail.com</span>');
  };

 const blurPhoneNumbers = (html) => {
  return html.replace(/[\d\s().+-]{7,}/g, (candidate) => {
    const phone = parsePhoneNumberFromString(candidate, "US");
    if (phone && phone.isValid()) {
      return `<span class="blurred">fakephone@gmail.com</span>`;
    }
    return candidate;
  });
};

  const blurEmailDomains = (html) => {
    const domainRegex = /@gmail\.com|@yahoo\.com|@outlook\.com|@hotmail\.com|@\w+\.\w+/gi;
    return html.replace(domainRegex, '<span class="blurred">protected@domain.com</span>');
  };

  const blurSpecificDomains = (html) => {
    const domainPattern = domainsNotAllowed.join('|').replace(/\./g, '\\.');
    const linkRegex = new RegExp(`<a[^>]*href=["'](https?:\\/\\/(www\\.)?(${domainPattern})[^"']*)["'][^>]*>.*?<\\/a>`, 'gi');
    const rawDomainRegex = new RegExp(`(?:https?:\\/\\/)?(?:www\\.)?(${domainPattern})\\b`, 'gi');
    return html
      .replace(linkRegex, '<span class="blurred">Domain not allowed</span>')
      .replace(rawDomainRegex, '<span class="blurred">Domain not allowed</span>');
  };

  let processed = convertLinksToAnchorTags(html);
 
  if(!LoginData?.isAdmin){
  processed = blurEmailAddresses(processed);
  processed = blurPhoneNumbers(processed);
  processed = blurEmailDomains(processed);
  processed = blurSpecificDomains(processed);
  }

  return processed;
};

  return (
    <div
      className={`relative ${
        (isTab) ? " messagboard-mobile-view " : " messagboard-desktop-view "
      }  row ${(isTab) ? "fade-in border border-light" : ""} `}
    >
      {!uuid && (
        <div
          className={`user-list-desktop ${
            showUserList ? "show" : ""
          }`}
          onClick={() => setShowUserList((prev) => !prev)}
        >
          <div
            className={`col-md-3  chat-list-side user-list-desktop-inner ${
              !isTab ?  " " : "chat-Box"
            } ${showUserList ? "slide-in" : "slide-out"}`}
			onClick={(e) => e.stopPropagation()}
          >
            <div className="clearfix mb-2">
              <AiOutlineSearch
                className="position-absolute search-icon"
                size={23}
                color="#6A737B"
              />
              <input
                type="text"
                className="form-control"
                style={{ paddingLeft: 35 }}
                placeholder="Find user..."
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <Scrollbar
              onScroll={handleScroll}
              width={3}
              ref={scrollContainerRef}
              className="w-100 m-0 p-0 chat-user-scrollbar"
            >
              <UsersList
                search={search}
                chatUsers={
                  chatUsers?.length > initialLoad
                    ? chatUsers?.slice(0, initialLoad)
                    : chatUsers
                }
                loadChats={loadChats}
                setOpenChat={setOpenChat}
                getMyStatus={allActions.firebase.getMyStatus}
                selectedReceiver={selectedReceiver}
				        setShowUserList={setShowUserList}
                isAiBotMode={isAiBotMode?.enable}
                setIsAiBotMode={setIsAiBotMode}
              />
               {load && (
                <Loader
                  size={{ width: "2rem", height: "2rem" }}
                  padding={10}
                  local={true}
                  loading={load}
                  customBg={"rgba(0,0,0,0)"}
                  viewClass="bg-transparent"
                />
              )} 
            </Scrollbar>
          </div>
        </div>
      )}
      {selectedReceiver && (
        <div
          className={`${
            isTab
              ? " messagboard-mobile-view-inner  chat-Box "
              : " messagboard-desktop-view-inner  chat-Box-desktop "
          } grow-width ${
            uuid
              ? "col-md-12 border border-1 border-light  py-2 rounded"
              : "col-md-9 border border-1 border-light  py-2 rounded"
          } overflow-hidden d-flex flex-column justify-content-between`}
        >
          <>
            <UserTopBar
              group={group}
              chatDisable={chatDisable}
              chatUsers={chatUsers.filter(
                (data) => group && group?.includes(data?.uuid) && data
              )}
              editable={editable}
              setMessage={setMessage}
              handleSubmit={handleSubmit}
              selectedReceiver={selectedReceiver}
              setMessageContent={setMessageContent}
              getMyStatus={allActions.firebase.getMyStatus}
              setShowUserList={setShowUserList}
			        showButtons = {false}
              isAiBotMode={isAiBotMode?.enable}
							toggleAiBotMode={toggleAiBotMode}
              modal={true}
              isAITyping={isAITyping}
            />
            {/* <Scrollbar
              ref={messagesEndRef}
              width={3}
              className="w-100 h-100 message-scrollbar-mobile"
            >
              <div className="chats-container">
                <div className="clearfix chatroom  chats-area">
                  {readPersonalChats &&
                    readPersonalChats
                      .sort((a, b) => a.createdAt - b.createdAt)
                      ?.map((data, index) => {
                        return (
                          <MessageCard
                            group={false}
                            data={data}
                            index={index}
                            key={index}
                            chatUsers={chatUsers}
                            editId={editId}
                            setEditId={setEditId}
                            setEditText={setEditText}
                          />
                        );
                      })}
                </div>
              </div>
            </Scrollbar> */}
                {(isAiBotMode.enable && !isAiTalkBefore)
                  ?
                  chatAreas(aiFirstQuestion)
                  :
                  chatAreas(readPersonalChats)
                }

          {editable && (
            <SubmitArea
              handleEdit={handleEdit}
              chatDisable={chatDisable}
              myIds={myIds}
              imageLinks={imageLinks}
              fileUpload={fileUpload}
              setIsTyping={setIsTyping}
              imagesArray={imagesArray}
              messageContent={messageContent}
              selectedReceiver={selectedReceiver}
              handleRemoveImage={handleRemoveImage}
              editorState={editorState}
              handleKeyPress={handleKeyPress}
              handleSubmit={handleSubmit}
              editMode={editId}
              setEditId={setEditId}
              editText={editText}
              setEditText={setEditText}
              docId={editId}
              isAiBotMode={isAiBotMode?.enable}
              toggleAiBotMode={toggleAiBotMode}
              isAITyping={isAITyping}
              getAIResponse={getAIResponse}
              readPersonalChats={readPersonalChats}
              isInModal={true}
              setMessageContent={setMessageContent}
              processPlainTextMessage={processPlainTextMessage}
            />
          )}
          </>
             { !isDesktop && showCustomerMessageBoard && (
                      <div
                        className={`${
                          isDesktop
                            ? "open-message-board-button-desktop"
                            : "open-message-board-button-absolute"
                        } cursor-pointer`}
                        onClick={() => setShowCustomerMessageBoard((prev) => !prev)}
                      >
                        {personalConnections?.notification &&
                         parseInt(personalConnections?.notification) > 1 ? (
                          <span
                            className="badge badge-notification bg-danger position-absolute top-0 rounded-circle end-3 right-0 mx-4"
                            style={{ fontSize: "14px", right: "-15px" }}
                          >
                            {personalConnections?.notification - 1}
                          </span>
                        ) : (
                          ""
                        )}
                        {showCustomerMessageBoard ? (
                          <IoMdClose color="white" />
                        ) : (
                          <RiMessage2Line color="white" />
                        )}
                    </div>
                  )}
        </div>
      )}
    </div>
  );
};

export default CustomerMessageBoardModal;
